import { CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";

const FileCardContent = styled(CardContent)(() => ({
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  flexGrow: 1,
}));

export default FileCardContent;
